import { BehaviorSubject, Observable } from "rxjs";

enum FIELD_COLOR {
	DEFAULT = "default",
	VALID = "valid",
	INVALID = "invalid"
}

export class PaysafeField {
	protected readonly colors: Map<string, string> = new Map([
		[FIELD_COLOR.DEFAULT, "#E5E9EC"],
		[FIELD_COLOR.VALID, "#27d17f"],
		[FIELD_COLOR.INVALID, "#D52B2B"]
	]);
	protected focused: boolean = false;
	protected isEmpty: boolean = true;
	protected currentColor: string = this.colors.get(FIELD_COLOR.DEFAULT);
	protected fieldElement: HTMLElement = null;
	protected style: CSSStyleDeclaration = null;

	constructor(
		protected _name: string,
		protected errorMsg: string
	) {}

	public get isInvalid(): boolean {
		return !this.isValid;
	}

	protected isValid: boolean = false;
	protected _isTouched: boolean = false;

	public get isTouched(): boolean {
		return this._isTouched;
	}

	protected _isValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public get isValid$(): Observable<boolean> {
		return this._isValid;
	}

	public get errorI18nKey(): string {
		return this.errorMsg;
	}

	public set field(el: HTMLElement) {
		if (this.fieldElement) {
			return;
		}

		this.fieldElement = el;
		this.style = el.style;
	}

	public get name(): string {
		return this._name;
	}

	public handleInitiatedField(field): void {
		field.valid((eventInstance, event) => this.onValid(eventInstance, event));
		field.invalid((eventInstance, event) => this.onInvalid(eventInstance, event));
		field.blur((eventInstance, event) => this.onBlur(eventInstance, event));
		field.focus((eventInstance, event) => this.onFocus(eventInstance, event));
		field.fieldValueChange((eventInstance, event) => this.onFieldValueChange(eventInstance, event));
		field.invalidCharacter((eventInstance, event) => this.onInvalidCharacter(eventInstance, event));
	}

	protected setValid(status: boolean): void {
		this.isValid = status;
		this._isValid.next(status);
		this._setColor(status);
	}

	protected onValid = (eventInstance, event): void => {
		this.field = event.target.containerElement;
		this.setValid(true);
	};

	protected onInvalid = (eventInstance, event): void => this.setValid(false);
	protected onFieldValueChange = (eventInstance, event): void => (this.isEmpty = event.data.isEmpty);
	protected onInvalidCharacter = (eventInstance, event): void =>
		this.setValid(eventInstance.fields(this.name).isValid());

	protected onFocus = (eventInstance, event): void => {
		this.focused = true;
		if (!this._isTouched) {
			this.currentColor = this.colors.get(FIELD_COLOR.VALID);
			this.field = event.target.containerElement;
		}
		this._setActiveField();
	};

	protected onBlur = (eventInstance, event): void => {
		this.focused = false;
		this._isTouched = true;
		this.setValid(eventInstance.fields(this.name).isValid());
	};

	protected _setActiveField(): void {
		this.style.borderColor = this.currentColor;
		this.style.boxShadow = `0 5px 10px -5px ${this.currentColor}`;
	}

	protected _setColor(valid: boolean): void {
		this.currentColor = this.colors.get(valid ? FIELD_COLOR.VALID : FIELD_COLOR.INVALID);
		this.style.borderColor = this.currentColor;
		this.style.boxShadow = this.focused ? `0 5px 10px -5px ${this.currentColor}` : "none";
	}
}
